import { toNumber } from '../../../../core/utils/lp-backend';
import { TerminateOrders } from '../../presentation/redux/types/settings-types';
import { writeSettingsFields } from './settings-fields';

/** `PATCH /client/settings/fields`: `settings.terminate_orders`. */
export const editTerminateOrders = async (terminate_orders: TerminateOrders): Promise<any> =>
  writeSettingsFields({
    terminate_orders: { ...terminate_orders, max_age: toNumber(terminate_orders?.max_age) }
  });
